import type { AppBrandingDto } from "@/api/types";
import { useProjectContext } from "@/providers/ProjectContext";

export function useProjectAppBranding(): AppBrandingDto | undefined {
  const projectContext = useProjectContext();

  return projectContext.projectAppBranding;
}
